import { Mail } from "lucide-react";
import Button from "../../components/ui/Button";
import Dialog from "../../components/ui/Dialog";

interface Props {
  userEmail: string;
  onConfirm: () => Promise<void>;
  onClose: () => void;
}

export default ({ userEmail, onConfirm, onClose }: Props) => {
  return (
    <Dialog title="Reset password" subtitle={userEmail} onClose={onClose} TitleIcon={Mail}>
      <div className="space-y-4">
        <p className="text-sm text-slate-600">
          This sends a password reset email with a temporary password and a secure link so the user can set a new password.
        </p>
        <div className="rounded-xl border border-slate-200 bg-slate-50 p-4">
          <p className="text-xs font-medium uppercase tracking-wide text-slate-400">Email</p>
          <p className="mt-1 text-sm font-semibold text-slate-900">{userEmail}</p>
        </div>
        <div className="flex justify-end gap-3">
          <Button type="button" variant="ghost" onClick={onClose}>Cancel</Button>
          <Button onClick={() => void onConfirm()}>
            Send reset email
          </Button>
        </div>
      </div>
    </Dialog>
  );
};
